let url = '<backend_url_goes_here>';
url = 'https://api.the-affordable-turkey.com/index.php/'
if (process.env.NODE_ENV === "development") {
    url = 'https://localhost:8085/index.php/'
}

export const BACKEND_URL = url;
export const APP_NAME = 'demeter';
